import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ClipboardList, Send, FileDown } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { formatDeShort } from "@/lib/date";
import { openPdf } from "@/components/WbAkteSections";

const KINDS = [
  { kind: "anamnese", label: "Anamnesebogen" },
  { kind: "selbsteinschaetzung", label: "Selbsteinschätzung" },
];

export default function QuestionnaireCard({ personKind, personId }) {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");
  const load = () => api.get(`/questionnaires/person/${personKind}/${personId}`).then((r) => setRows(r.data)).catch(() => setRows(null));
  useEffect(() => { load(); }, [personKind, personId]); // eslint-disable-line
  if (!rows) return null;
  const send = async (k) => {
    if (!window.confirm(`${k.label} per E-Mail an den Kunden senden?`)) return;
    setBusy(k.kind);
    try {
      const { data } = await api.post(`/questionnaires/send/${k.kind}/${personKind}/${personId}`);
      toast.success(`${k.label} an ${data.email} gesendet`);
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(""); }
  };
  return (
    <div className="border border-slate-200 bg-white px-5 py-4 mt-6" data-testid="questionnaire-card">
      <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mb-3 flex items-center gap-2">
        <ClipboardList size={13} /> Anamnese & Selbsteinschätzung
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {KINDS.map((k) => {
          const last = rows.find((r) => r.kind === k.kind);
          const done = rows.find((r) => r.kind === k.kind && r.submitted);
          return (
            <div key={k.kind} className="border border-slate-200 p-3 flex flex-col gap-2" data-testid={`questionnaire-${k.kind}`}>
              <div className="text-sm font-medium text-slate-900">{k.label}</div>
              <div className="text-xs text-slate-600" data-testid={`questionnaire-${k.kind}-status`}>
                {done ? `Ausgefüllt am ${formatDeShort(done.submitted_at)}`
                  : last ? `Gesendet am ${formatDeShort(last.sent_at)} · noch offen${last.reminder_sent_at ? ` · erinnert am ${formatDeShort(last.reminder_sent_at)}` : ""}` : "Noch nicht gesendet"}
              </div>
              <div className="flex gap-2 flex-wrap">
                <button onClick={() => send(k)} disabled={!!busy} data-testid={`questionnaire-${k.kind}-send-btn`}
                  className="px-3 py-1.5 text-xs font-medium border border-slate-300 hover:bg-slate-100 disabled:opacity-50 flex items-center gap-1.5">
                  <Send size={12} strokeWidth={1.5} /> {busy === k.kind ? "Sendet…" : last ? "Erneut senden" : "Senden"}
                </button>
                {done && (
                  <button onClick={() => openPdf(`/questionnaires/${done.q_id}/pdf`, `${k.label}.pdf`)} data-testid={`questionnaire-${k.kind}-pdf-btn`}
                    className="px-3 py-1.5 text-xs font-medium bg-slate-900 text-white hover:bg-black flex items-center gap-1.5">
                    <FileDown size={12} strokeWidth={1.5} /> Antworten (PDF)
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
